import httpClient from "./httpClient";
import qs from "qs";
import type { ApiResponse, DelegateUserPayload } from "../types/api";

export default class ProfileDelegateApi {
  static getPermissions(): Promise<ApiResponse> {
    return httpClient.get(API_URL + "/module").then((response) => response.data);
  }

  static getDelegateUsers(): Promise<ApiResponse> {
    return httpClient.get(API_URL + "/delegate_user").then((response) => response.data);
  }

  static getDelegateUser(id: number | string): Promise<ApiResponse> {
    return httpClient.get(API_URL + "/delegate_user/" + id).then((response) => response.data);
  }

  static updateDelegateUser(
    id: number | string,
    formData: DelegateUserPayload
  ): Promise<ApiResponse> {
    return httpClient
      .put(API_URL + "/delegate_user/" + id, qs.stringify(formData))
      .then((response) => response.data);
  }

  static createDelegateUser(formData: DelegateUserPayload): Promise<ApiResponse> {
    return httpClient
      .post(API_URL + "/delegate_user", qs.stringify(formData))
      .then((response) => response.data);
  }

  static deleteDelegateUser(id: number | string): Promise<ApiResponse> {
    return httpClient.delete(API_URL + "/delegate_user/" + id).then((response) => response.data);
  }
}
